export enum ReturnType {
  Order = "Order",
  Import = "Import",
  Stock = "Stock",
}

export const ReturnTypeLabel = {
  [ReturnType.Order]: '주문',
  [ReturnType.Import]: '입고',
  [ReturnType.Stock]: '재고',
}

export enum ReturnReason {
  DefectiveStock = "Defective Stock",
  ShortSellingStock = "Short-selling Stock",
  Others = "Others",
}

export enum ProcessType {
  Return = "return",
  Disposal = "disposal",
}

export enum WarehouseReturnStatus {
  Request = "Request",
  Inprogress = "Inprogress",
  Complete = "Complete",
}

export const WarehouseReturnStatusLabel = {
  [WarehouseReturnStatus.Request]: '검수대기',
  [WarehouseReturnStatus.Inprogress]: '검수중',
  [WarehouseReturnStatus.Complete]: '검수완료',
}

export const WarehouseReturnDisposalStatusLabel = {
  [WarehouseReturnStatus.Request]: '폐기요청',
  [WarehouseReturnStatus.Inprogress]: '폐기중',
  [WarehouseReturnStatus.Complete]: '폐기완료',
}

export enum ReturnStatus {
  Request = "Request",
  Inprogress = "Inprogress",
  Completed = "Completed",
}

export const ReturnStatusLabel = {
  [ReturnStatus.Request]: '반품요청',
  [ReturnStatus.Inprogress]: '처리중',
  [ReturnStatus.Completed]: '반품완료',
}

export enum DisposalStatus {
  Request = "Request",
  Inprogress = "Inprogress",
  Completed = "Completed",
}

export const DisposalStatusLabel = {
  [DisposalStatus.Request]: '반품요청',
  [DisposalStatus.Inprogress]: '처리중',
  [DisposalStatus.Completed]: '반품완료',
}

export enum OrderStatus {
  Request = "Request",
  Inprogress = "Inprogress",
  Complete = "Complete",
}

export const OrderStatusText = {
  [OrderStatus.Request]: '배송요청',
  [OrderStatus.Inprogress]: '배송중',
  [OrderStatus.Complete]: '배송완료',
}

export enum SellerOrderStatus {
  Saved = "Saved",
  Request = "Request",
  Inprogress = "Inprogress",
  Delivered = "Delivered",
  //below is amazon order status
  Upcoming = "Upcoming",
  Pending = "Pending",
  Unshipped = "Unshipped",
  PartiallyShipped = "PartiallyShipped",
  Shipped = "Shipped",
  Canceled = "Canceled",
  Unfulfillable = "Unfulfillable",
  InvoiceUnconfirmed = "InvoiceUnconfirmed",
  PendingAvailability = "PendingAvailability",
}
